import React, { useState } from 'react';
import MainLayout from './MainLayout';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  BarElement, ArcElement, Tooltip, Legend, Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { 
  Database, Users, Package, FileText, 
  ChevronRight, ArrowUpRight, Search, Download 
} from 'lucide-react';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Tooltip, Legend, Filler);

const Dashboard = () => {
  const [activeTable, setActiveTable] = useState('fastMoving');
  const data = {
    "roleWiseUders":{
        "bsp":8,
        "dsp":14,
        "bd":2,
        "ic":8,
        "salesEnabler":4,
        "dealer":12,
        "studio":9
    },
    "users":{
        "totalUsers":57,
        "activeUsers":45,
        "inactiveUsers":12
    },
    "anyalytics":{
        "totalQuotations":1200,
        "totalClients":300,
        "totalDrafts":120
    },
    "products":{
        "totalProducts":12000,
        "productWithImages":9500,
        "productWithoutImages":2500
    },
    "quotationStages":{
        "enquiries":300,
        "inPipeline":500,   
        "converted":350,
        "lost":50
    },
    "userWiseQuotations":[
        {
            "id": 347,
            "name": "Rajendra Kumar",
            "last_name": "Lohar",
            "emp_code": "100689230",
            "city": "NORTH",
            "state": "RAJASTHAN",
            "role_id": 3,
            "total_projects": 66
        },
        {
            "id": 353,
            "name": "Nasina",
            "last_name": "Ganesh",
            "emp_code": "100693217",
            "city": "SOUTH 2",
            "state": "ANDHRA PRADESH",
            "role_id": 3,
            "total_projects": 35
        }
    ],
    "topClientsByQuotations":[
        {
            "client": "ABC Corp",
            "quotations": 120
        },
        {
            "client": "XYZ Ltd",
            "quotations": 95
        }
    ],
    "topUserByQuotations":[
        {
            "user": "Akash Sharma",
            "quotations": 80
        },
        {
            "user": "Sanjay Singh",
            "quotations": 75
        }
    ],
    "fastMovingProducts":[
        {
            "sku_code": "SKU123",
            "quotations": 150,
            "useCount": 300,
            "product_desc": "Product A Description",
            "brand": "BrandA",
            "collection": "CollectionA",
            "finish": "Matte",
        },
        {
            "sku_code": "SKU456",
            "quotations": 120,
            "useCount": 250,
            "product_desc": "Product B Description",
            "brand": "BrandB",
            "collection": "CollectionB",
            "finish": "Glossy"
        }
    ],
    "g3PriceSegmentProducts":[
        {
            "sku_code": "SKU789",
            "quotations": 100,
            "useCount": 200,
            "product_desc": "Product C Description",
            "brand": "BrandC",
            "collection": "CollectionC",
            "finish": "Satin"
        },
        {
            "sku_code": "SKU101",
            "quotations": 90,
            "useCount": 180,
            "product_desc": "Product D Description",
            "brand": "BrandD",
            "collection": "CollectionD",
            "finish": "Textured"
        }
    ],
    "g4PriceSegmentProducts":[
        {
            "sku_code": "SKU112",
            "quotations": 80,
            "useCount": 160,
            "product_desc": "Product E Description",
            "brand": "BrandE",
            "collection": "CollectionE",
            "finish": "Polished"
        },
        {
            "sku_code": "SKU113",
            "quotations": 70,
            "useCount": 140,
            "product_desc": "Product F Description",
            "brand": "BrandF",
            "collection": "CollectionF",
            "finish": "Brushed"
        }
    ],
    "g5PriceSegmentProducts":[
        {
            "sku_code": "SKU114",
            "quotations": 60,
            "useCount": 120,
            "product_desc": "Product G Description",
            "brand": "BrandG",
            "collection": "CollectionG",
            "finish": "Natural"
        },
        {
            "sku_code": "SKU115",
            "quotations": 50,
            "useCount": 100,
            "product_desc": "Product H Description",
            "brand": "BrandH",
            "collection": "CollectionH",
            "finish": "Antique"
        }
    ],
    "topBrandUsage":[
        {
            "brand": "BrandA",
            "quotations": 300,
            "usageCount": 500
        },
        {
            "brand": "BrandB",
            "quotations": 250,
            "usageCount": 450
        }
    ],
    "topCollectionUsage":[
        {
            "collection": "CollectionA",
            "quotations": 200,
            "usageCount": 400
        },
        {
            "collection": "CollectionB",
            "quotations": 180,
            "usageCount": 350
        }
    ],
    "todayLogins":[
        {
            "user": "Ramesh Kumar",
            "login_time": "2024-10-01T09:00:00Z"
        },
        {
            "user": "Sita Devi",
            "login_time": "2024-10-01T10:30:00Z"
        }
    ],
    "quotationByMonth":[
        {
            "month": "January",
            "quotations": 100
        },
        {
            "month": "February",
            "quotations": 120
        },
        {
            "month": "March",
            "quotations": 150
        }
    ],
    "regionsWiseQuotations":[
        {
            "region": "North",
            "quotations": 400
        },
        {
            "region": "South",
            "quotations": 350
        }
    ],
    "regionWiseClients":[
        {
            "region": "East",
            "clients": 80
        },
        {
            "region": "West",
            "clients": 70
        }
    ],
    "stateWiseQuotations":[
        {
            "state": "California",
            "quotations": 200
        },
        {
            "state": "Texas",
            "quotations": 180
        }
    ]
};

  return (
    <MainLayout>
      <div className="min-h-screen bg-[#F8FAFC] text-[#1E293B]">
        
        {/* --- FIXED ENTERPRISE HEADER --- */}
        <header className="sticky top-0 z-[100] w-full bg-white border-b border-slate-200 px-8 py-3 shadow-sm">
          <div className="flex items-center justify-between max-w-[1800px] mx-auto">
            <div className="flex items-center gap-4">
              <div className="bg-indigo-600 p-2 rounded-lg text-white"><Database size={20}/></div>
              <h1 className="text-xl font-bold tracking-tight">Admin Console <span className="text-slate-400 font-medium">/ Overview</span></h1>
            </div>

            <div className="flex items-center gap-3">
              <HeaderSelect label="Year" options={['2026', '2025']} />
              <HeaderSelect label="Month" options={['January', 'February', 'All']} />
              <HeaderSelect label="User" options={['All Users', 'Active']} />
              <HeaderSelect label="Role" options={['All Roles', ...Object.keys(data.roleWiseUders)]} />
              <div className="h-8 w-px bg-slate-200 mx-2" />
              <button className="flex items-center gap-2 bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-indigo-600 transition">
                <Download size={16}/> Export Data
              </button>
            </div>
          </div>
        </header>

        <main className="p-8 space-y-8 max-w-[1800px] mx-auto">
          
          {/* --- SECTION 1: KPI SUMMARY (Objects Only) --- */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <MetricBlock title="users" main={data.users.totalUsers} 
              details={[{ label: 'Active', val: data.users.activeUsers }, { label: 'Inactive', val: data.users.inactiveUsers }]} icon={<Users/>} />
            
            <MetricBlock title="anyalytics" main={data.anyalytics.totalQuotations} 
              details={[{ label: 'Clients', val: data.anyalytics.totalClients }, { label: 'Drafts', val: data.anyalytics.totalDrafts }]} icon={<FileText/>} />
            
            <MetricBlock title="products" main={data.products.totalProducts} 
              details={[{ label: 'With Images', val: data.products.productWithImages }, { label: 'Without', val: data.products.productWithoutImages }]} icon={<Package/>} />
            
            <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
              <p className="text-[11px] font-bold text-slate-400 uppercase mb-3">roleWiseUders</p>
              <div className="grid grid-cols-2 gap-2">
                {Object.entries(data.roleWiseUders).slice(0, 4).map(([k, v]) => (
                  <div key={k} className="text-xs font-bold text-slate-600 bg-slate-50 p-1.5 rounded">{k}: {v}</div>
                ))}
              </div>
            </div>
          </div>

          {/* --- SECTION 2: CHARTS & STAGES --- */}
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 lg:col-span-9 bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
              <p className="text-sm font-bold text-slate-800 mb-6 uppercase">quotationByMonth & Trends</p>
              <div className="h-[250px]">
                <Line options={lineOptions} data={{
                  labels: data.quotationByMonth.map(m => m.month),
                  datasets: [{ label: 'Quotes', data: data.quotationByMonth.map(m => m.quotations), borderColor: '#4F46E5', tension: 0.4, fill: true, backgroundColor: 'rgba(79, 70, 229, 0.05)' }]
                }} />
              </div>
            </div>
            <div className="col-span-12 lg:col-span-3 space-y-4">
              <p className="text-sm font-bold text-slate-800 uppercase">quotationStages</p>
              {Object.entries(data.quotationStages).map(([stage, val]) => (
                <div key={stage} className="bg-white p-4 rounded-xl border border-slate-200 flex justify-between items-center">
                   <span className="text-xs font-bold text-slate-500 uppercase">{stage}</span>
                   <span className="text-lg font-bold text-indigo-600">{val}</span>
                </div>
              ))}
            </div>
          </div>

          {/* --- SECTION 3: THE DATA ENGINE (Handling Arrays) --- */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="bg-slate-50 border-b border-slate-200 p-4 flex justify-between items-center">
              <div className="flex gap-1">
                <TabBtn active={activeTable === 'fastMoving'} label="fastMovingProducts" onClick={() => setActiveTable('fastMoving')} />
                <TabBtn active={activeTable === 'userWise'} label="userWiseQuotations" onClick={() => setActiveTable('userWise')} />
                <TabBtn active={activeTable === 'g3'} label="g3PriceSegment" onClick={() => setActiveTable('g3')} />
                <TabBtn active={activeTable === 'g4'} label="g4PriceSegment" onClick={() => setActiveTable('g4')} />
                <TabBtn active={activeTable === 'g5'} label="g5PriceSegment" onClick={() => setActiveTable('g5')} />
                <TabBtn active={activeTable === 'misc'} label="Brands/Clients" onClick={() => setActiveTable('misc')} />
              </div>
              <div className="relative">
                <Search className="absolute left-3 top-2.5 text-slate-400" size={14}/>
                <input type="text" placeholder="Search rows..." className="pl-9 pr-4 py-1.5 text-xs border border-slate-200 rounded-lg focus:ring-1 focus:ring-indigo-500 outline-none w-64" />
              </div>
            </div>

            <div className="overflow-x-auto max-h-[600px]">
              {activeTable === 'fastMoving' && (
                <DataTable 
                  headings={['sku_code', 'quotations', 'useCount', 'brand', 'collection', 'finish']} 
                  rows={data.fastMovingProducts} 
                />
              )}
              {activeTable === 'userWise' && (
                <DataTable 
                  headings={['emp_code', 'name', 'last_name', 'city', 'state', 'total_projects']} 
                  rows={data.userWiseQuotations} 
                />
              )}
              {activeTable === 'g3' && <DataTable headings={['sku_code', 'brand', 'useCount', 'product_desc', 'finish']} rows={data.g3PriceSegmentProducts} />}
              {activeTable === 'g4' && <DataTable headings={['sku_code', 'brand', 'useCount', 'product_desc', 'finish']} rows={data.g4PriceSegmentProducts} />}
              {activeTable === 'g5' && <DataTable headings={['sku_code', 'brand', 'useCount', 'product_desc', 'finish']} rows={data.g5PriceSegmentProducts} />}
              
              {activeTable === 'misc' && (
                <div className="grid grid-cols-2 p-6 gap-8 bg-white">
                  <SubTable title="topClientsByQuotations" data={data.topClientsByQuotations} cols={['client', 'quotations']} />
                  <SubTable title="topUserByQuotations" data={data.topUserByQuotations} cols={['user', 'quotations']} />
                  <SubTable title="topBrandUsage" data={data.topBrandUsage} cols={['brand', 'usageCount']} />
                  <SubTable title="topCollectionUsage" data={data.topCollectionUsage} cols={['collection', 'usageCount']} />
                  <SubTable title="regionsWiseQuotations" data={data.regionsWiseQuotations} cols={['region', 'quotations']} />
                  <SubTable title="todayLogins" data={data.todayLogins} cols={['user', 'login_time']} />
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </MainLayout>
  );
};

// --- ENTERPRISE COMPONENTS ---

const HeaderSelect = ({ label, options }) => (
  <div className="flex flex-col">
    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-tight leading-none mb-1">{label}</span>
    <select className="text-xs font-bold text-slate-700 bg-transparent border-none p-0 focus:ring-0 cursor-pointer">
      {options.map(o => <option key={o}>{o}</option>)}
    </select>
  </div>
);

const MetricBlock = ({ title, main, details, icon }) => (
  <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
    <div className="flex justify-between items-start mb-4">
      <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg">{icon}</div>
      <p className="text-[11px] font-bold text-slate-400 uppercase tracking-wider">{title}</p>
    </div>
    <div className="flex items-baseline gap-2 mb-4">
      <h2 className="text-2xl font-black">{main}</h2>
      <ArrowUpRight size={14} className="text-emerald-500" />
    </div>
    <div className="flex gap-4 border-t border-slate-50 pt-3">
      {details.map(d => (
        <div key={d.label}>
          <p className="text-[10px] text-slate-400 font-bold uppercase">{d.label}</p>
          <p className="text-sm font-bold text-slate-700">{d.val}</p>
        </div>
      ))}
    </div>
  </div>
);

const TabBtn = ({ active, label, onClick }) => (
  <button onClick={onClick} className={`px-4 py-2 text-xs font-bold transition-all border-b-2 ${active ? 'border-indigo-600 text-indigo-600 bg-white' : 'border-transparent text-slate-400 hover:text-slate-600'}`}>
    {label}
  </button>
);

const DataTable = ({ headings, rows }) => (
  <table className="w-full text-left border-collapse">
    <thead className="sticky top-0 bg-slate-50 z-10 shadow-sm">
      <tr>
        {headings.map(h => <th key={h} className="px-6 py-3 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-200">{h}</th>)}
      </tr>
    </thead>
    <tbody className="divide-y divide-slate-100">
      {rows.map((row, i) => (
        <tr key={i} className="hover:bg-slate-50 transition-colors group">
          {headings.map(h => (
            <td key={h} className="px-6 py-4 text-sm font-medium text-slate-600 group-hover:text-indigo-600">
              {h === 'login_time' ? new Date(row[h]).toLocaleTimeString() : row[h]}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const SubTable = ({ title, data, cols }) => (
  <div className="space-y-3">
    <p className="text-xs font-black text-indigo-600 uppercase tracking-tighter border-l-2 border-indigo-600 pl-2">{title}</p>
    <div className="border border-slate-100 rounded-lg overflow-hidden">
      <table className="w-full text-xs text-left">
        <thead className="bg-slate-50">
          <tr>{cols.map(c => <th key={c} className="p-2 text-slate-400 uppercase">{c}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-50">
          {data.map((r, i) => (
            <tr key={i} className="hover:bg-indigo-50/30">
              {cols.map(c => <td key={c} className="p-2 font-bold text-slate-600">{r[c]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const lineOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: { y: { border: { display: false }, grid: { color: '#F1F5F9' } }, x: { grid: { display: false } } }
};

export default Dashboard;